import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import cn from '../modules/cn'

function SubNavigation({ navigationItems, className }) {
  return (
    <nav className={cn('h-12 flex items-end space-x-6', className)}>
      {(navigationItems || []).map(({ key, isActive, ...navItem }) => (
        <NavLink
          key={key || navItem.to}
          className={({ isActive: isPathActive }) => cn(
            'leading-normal text-h6 font-extrabold hover:text-gray-900',
            'hover:border-gray-400 border-b-2 whitespace-nowrap p-1',
            (isActive || isPathActive) && 'text-theme-500 border-theme-500',
            !(isActive || isPathActive) && 'text-gray-500 border-transparent',
          )}
          {...navItem /* eslint-disable-line react/jsx-props-no-spreading */}
        />
      ))}
    </nav>
  )
}

SubNavigation.propTypes = {
  navigationItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
    })]),
    exact: PropTypes.bool,
  })),
  className: cn.propType,
}

SubNavigation.defaultProps = {
  navigationItems: null,
  className: null,
}

export default SubNavigation
